import React, { useEffect, useLayoutEffect, useState } from "react";
// import "./App.css";
import { Route, Routes, Navigate } from "react-router-dom";
// import RedemptionForm from "./components/RedemptionForm";
// import UserformSurvey from "./components/UserformSurvey";
// import UserForm from "./components/UserForm";
// import Thankyou from "./components/Thankyou";
// import Index from "./components/Index";
// import CertDetails from "./components/CertDetails";
import NoInternet from "./components/NoInternet";
import RegisterForm from "./components/RegisterForm";
import TestOurTech_thankyou from "./components/TestOurTech_thankyou";
import UserformService from "./services/userform.service";
import { Helmet } from "react-helmet";
import NotFound from "./components/NotFound";
function App() {
  useEffect(() => {
    localStorage.setItem("isVoucher", false);
  }, []);
  // checking of redeemption and register
  const [permissions, setPermissions] = useState(null);
  const [permissionsLoading, setPermissionsLoading] = useState(true);

  const LoadingBox = () => {
    return (
      <>
        <div className={`loader in bg-white`}>
          <div className="spinner-border main-spin"></div>
        </div>
      </>
    );
  };

  useLayoutEffect(() => {
    const getSiteDetailsPer = async () => {
      try {
        setPermissionsLoading(true);
        const response = await UserformService.getSitePermissions();

        setPermissions(response?.data?.response || null);
        setPermissionsLoading(false);
      } catch (error) {
        setPermissions(null);
        setPermissionsLoading(false);
      }
    };
    getSiteDetailsPer();
  }, []);
  // checking of redeemption and register end
  if (process.env.REACT_APP_STAGE === "PROD")
    console.log = function no_console() {};
  return (
    //FIXME UserformSurvey -> survey-form, UserForm -> user-form, Thankyou -> redemption-thankyou, TestOurTech_thankyou -> registration-thankyou
    <NoInternet>
      <Routes>
        {/* <Route path="/" element={<RedemptionForm />} /> */}
        {/* <Route path="/survey-form" element={<UserformSurvey />} /> */}
        {/* <Route path="/user-form" element={<UserForm />} /> */}
        {/* <Route path="/redemption-thankyou" element={<Thankyou />} /> */}
        {/* <Route path="/register/" element={<Index />} /> */}
        {/* <Route path="/certificate-details" element={<CertDetails />} /> */}
        <Route
          path="/"
          element={
            permissionsLoading ? (
              <LoadingBox />
            ) : permissions?.register === "yes" ? (
              <RegisterForm />
            ) : (
              <NotFound />
            )
          }
        />
        <Route
          path="/register/registration-thankyou"
          element={
            permissionsLoading ? (
              <LoadingBox />
            ) : permissions?.register === "yes" ? (
              <TestOurTech_thankyou />
            ) : (
              <NotFound />
            )
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </NoInternet>
  );
}

export default App;
